import * as angular from "angular";
import * as _ from "lodash";
import { ConfigScope, EquipmentDataPoint } from "./config.base";
import UIUtilityServiceName, {
  EnumOption,
  UIUtilityService,
} from "../../services/utility/uiUtility.service";
import NewGuidServiceName, {
  NewGuidService,
} from "../../services/utility/newguid.service";
import { apsEnums } from "../../shared/dto/aps.enums";
import { PlantLocation } from "../../services/locations/locations.service";
import template from "./cbitDataPoints.tpl.html";

let requires = [NewGuidServiceName, UIUtilityServiceName];

interface CbitDataPointsScope extends ConfigScope {
  types: EnumOption[];
  locations: PlantLocation[];
  addDataPoint(): void;
  removeDataPoint(dataPoint: EquipmentDataPoint): void;
}

export default angular
  .module("aps.controller.cbitDataPoints", requires)
  .directive("apsCbitDataPoints", cbitDataPoints).name;

function cbitDataPoints(
  newGuidService: NewGuidService,
  uiUtilityService: UIUtilityService
): angular.IDirective {
  return {
    restrict: "E",
    template: template,
    link: (scope: CbitDataPointsScope) => {
      var dataPointTypes = uiUtilityService.getListOptionsFromEnum(
        apsEnums.DataPointType,
        1
      );
      scope.types = _.filter(
        dataPointTypes,
        (dp) => dp.value === 1 || dp.value === 2
      );

      scope.vm.dataPoints = _.sortBy(scope.vm.dataPoints, [
        "jsonConfig.Channel",
        "name",
      ]);
      scope.addDataPoint = () => {
        let dataPoint = {
          config: null,
          jsonConfig: {Defect: false},
          configType: scope.vm.instance.type ===  apsEnums.EquipmentType.CBIT ? apsEnums.DataPointConfigType.CBITCounter : apsEnums.DataPointConfigType.CyclopsCounter,
          id: null,
          name: "",
          type: null,          
          plantLocationId: scope.vm.location.location.id,
        };
        newGuidService
          .getNewGuid("dataPoint")
          .then((id) => (dataPoint.id = id));
        scope.vm.dataPoints.push(dataPoint);
      };

      let setDataPointLocations = () => {
        scope.locations = [scope.vm.location].concat(
          scope.vm.location.children
        );

        scope.vm.dataPoints.forEach((dp) => {
          if (
            _.some(scope.locations, (l) => l.location.id === dp.plantLocationId)
          ) {
            return;
          }
          dp.plantLocationId = scope.vm.location.location.id;
        });
      };
      let watchLocation = scope.$watch("vm.location", setDataPointLocations);
      setDataPointLocations();

      scope.removeDataPoint = (dataPoint: EquipmentDataPoint) =>
        _.remove(scope.vm.dataPoints, dataPoint);

      scope.$on("$destroy", () => watchLocation());
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/equipment/cbitDataPoints.directive.ts